export default "assets/images/bf67cc860289b85c0402a4d4f890a3bd.png";